/* eslint-disable @typescript-eslint/no-explicit-any */
import { get } from 'lodash';
import { apiApp } from 'api/request';
import urlApp from 'api/urlApp';
import HttpRequestError from '../../utils/HttpRequetsError';

export async function getTrackingOrderApi(payload: any): Promise<any[]> {
  const res = await apiApp.get(urlApp.getTrackingOrderApiPath, {
    params: payload
  });
  if (get(res, 'status') === 200) return res.data;
  throw new HttpRequestError(res.data.error, res.data.message);
}
